export const getProfile = (store) => store.profile?.profile;
